import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-phone',
  templateUrl: './icon-phone.component.html',
  styleUrls: ['./icon-phone.component.scss'],
})
export class IconPhoneComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
